import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import PropTypes from "prop-types";
import { useContext, useMemo, useState } from "react";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { getUpdatedCampaignConfiguration } from "../../campaign/campaignUtils";

const getActivitiesFromCampaign = (campaign) =>
  campaign.value?.requirement?.possibleActivities || [];

const formatActivityOption = (activity) => ({
  id: activity.slug,
  displayText: activity.name || activity.slug,
});

const getUniqueActivityOptions = (campaigns = []) => {
  const activityMap = new Map();

  campaigns.forEach((campaign) => {
    getActivitiesFromCampaign(campaign).forEach((activity) => {
      if (!activityMap.has(activity.slug)) {
        activityMap.set(activity.slug, formatActivityOption(activity));
      }
    });
  });

  return Array.from(activityMap.values()).sort((a, b) =>
    a.displayText.localeCompare(b.displayText)
  );
};

const ActivityTypeSelectorComponent = (props) => {
  const { handleChange, label, path, required, uischema, visible, enabled } = props;

  const [selected, setSelected] = useState([]);
  const { campaignsConfiguration, campaignGroups } = useContext(GlobalConfigContext);

  const updatedCampaignConfiguration = getUpdatedCampaignConfiguration(
    campaignsConfiguration,
    campaignGroups
  );

  // Extract all unique activities from all campaigns
  const activityOptions = useMemo(
    () => getUniqueActivityOptions(updatedCampaignConfiguration),
    [updatedCampaignConfiguration]
  );

  const formatData = (data) => (data ? data.map((item) => item.id) : []);

  const handleSelectValue = (val) => {
    setSelected(val);
    handleChange(path, formatData(val));
  };

  // Determine selection mode based on uiSchema options
  const selectionMode =
    uischema?.options?.multiple === false ? "singular" : "multiple";

  return visible ? (
    <div className="multiple-select-wrap">
      <Dropdown
        label={label}
        childList={activityOptions}
        selection={selectionMode}
        isRequired={required}
        disabled={!enabled}
        selectedValue={selected || undefined}
        placeholder={uischema.placeholder || "Select Activity"}
        setSelectedValue={handleSelectValue}
      />
    </div>
  ) : null;
};

ActivityTypeSelectorComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  required: PropTypes.bool,
  uischema: PropTypes.shape({
    options: PropTypes.shape({
      multiple: PropTypes.bool,
    }),
    placeholder: PropTypes.string,
  }),
  visible: PropTypes.bool,
  enabled: PropTypes.bool,
};

export const ActivityTypeSelectorControl = withJsonFormsMultiEnumProps(
  ActivityTypeSelectorComponent
);
